import React from 'react';
import { getStatusDisplayName, getStatusColor } from '../../utils/autoplanner/taskUtils';

const TaskStatus = ({ status }) => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${getStatusColor(status)}`}
  >
    {getStatusDisplayName(status)}
  </span>
);

export default TaskStatus;
